<template>
  <div class="wh100">
    <LayoutTopFilter
      title="单站点多指标统计"
      style="background: #fff"
      content-class="custom-content"
    >
      <template slot="filter">
        <el-form ref="form" :model="params" :inline="true" :rules="form.rules">
          <el-form-item prop="beginTime" v-if="params.dataType == 'year'">
            <el-date-picker
              v-model="params.beginTime"
              :type="form.timeType"
              placeholder="开始年份"
              :format="form.timeFormat"
              :value-format="form.timeFormat"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
          <el-form-item prop="endTime" v-if="params.dataType == 'year'">
            <el-date-picker
              v-model="params.endTime"
              :type="form.timeType"
              placeholder="结束年份"
              :format="form.timeFormat"
              :value-format="form.timeFormat"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>

          <el-form-item prop="beginTime" v-if="params.dataType == 'quarter'">
            <QuarterPicker
              ref="QuarterPicker1"
              :defaultValue="params.beginTime"
              @chooseSeason="beginSeasonChange"
            ></QuarterPicker>
          </el-form-item>
          <el-form-item prop="endTime" v-if="params.dataType == 'quarter'">
            <QuarterPicker
              ref="QuarterPicker2"
              :defaultValue="params.endTime"
              @chooseSeason="endSeasonChange"
            ></QuarterPicker>
          </el-form-item>

          <el-form-item>
            <el-select
              v-model="selectedChannelIDs"
              multiple
              collapse-tags
              clearable
              @change="QueryData"
              placeholder="请选择指标"
            >
              <el-option
                v-for="item in channelList"
                :key="item.ChannelMap"
                :label="item.ChannelName"
                :value="item.ChannelMap"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="QueryData"
              >查询</el-button
            >
          </el-form-item>
          <el-radio-group style="margin-right: 10px" v-model="params.dataType">
            <el-radio-button label="quarter">季度</el-radio-button>
            <el-radio-button label="year">年度</el-radio-button>
          </el-radio-group>
        </el-form>
      </template>
      <template slot="content">
        <LayoutLeftCollapse>
          <template slot="left">
            <MyPanel>
              <StationTree
                @checkchange="treechange"
                :singlecheck="singlecheck"
                @loaded="loaded"
              ></StationTree>
            </MyPanel>
          </template>
          <template slot="right-content">
            <MyPanel>
              <MyChart
                :defOptions="chart.options"
                :change="chart.myChange"
                ref="mychart"
              ></MyChart>
            </MyPanel>
          </template>
        </LayoutLeftCollapse>
      </template>
    </LayoutTopFilter>
  </div>
</template>

<script>
import LayoutLeftCollapse from "../../components/layout/LayoutLeftCollapse";
import LayoutTopFilter from "../../components/layout/LayoutTopFilter";
import MyPanel from "../../components/Pannel/Pannel";
import StationTree from "../../views/DataAnalysis/components/StationTree";
import QuarterPicker from "../../views/DataAnalysis/components/QuarterPicker";
import MyChart from "../../components/EChart";

export default {
  
  components: {
    LayoutLeftCollapse,
    LayoutTopFilter,
    MyPanel,
    StationTree,
    MyChart,
    QuarterPicker,
  },
  data() {
    return {
      channelList: [],
      selectedChannelIDs: "", //选中的指标iD集合
      singlecheck: true,

      params: {
        beginTime: this.$util.getSeason(-3),
        endTime: this.$util.getSeason(0),
        stations: "",
        dataType: "quarter",
        channelIDs: "",
      },
      chart: {
        myChange: 1,
        options: {
          title: {
            text: "",
          },
          grid: {
            left: 40,
            right: 40,
            bottom: 25,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: [],
          },
          toolbox: {
            show: true,
            feature: {
              saveAsImage: {
                name: "单站点多指标统计",
              },
            },
          },
          yAxis: [
            {
              name: "指标值",
              type: "value",
            },
          ],
          tooltip: {
            valueSuffix: "", // 提示信息所带单位
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            show: true,
            selected: {},
            data: [],
          },
          series: [],
          animationEasing: "elasticOut",
          animationDelayUpdate: function (idx) {
            return idx * 5;
          },
        },
      },
      form: {
        rules: {
          beginTime: [
            { required: true, message: "请选择开始时间", trigger: "blur" },
          ],
          endTime: [
            { required: true, message: "请选择结束时间", trigger: "blur" },
          ],
        },
        //时间格式
        timeFormat: "yyyy-MM-dd HH:mm",
        timeType: "datetime",
      },
    };
  },
  methods: {
    beginSeasonChange(val) {
      this.params.beginTime = val;
    },
    endSeasonChange(val) {
      this.params.endTime = val;
    },
    treechange(arr) {
      this.params.stations = arr.join(",");
      this.QueryData();
    },
    loaded(stationid) {
      this.params.stations = stationid.join(",");
      this.QueryData();
    },
    QueryData() {
      let that = this;

      that.params.channelIDs = that.selectedChannelIDs.join(",");
      if (!that.params.stations && !that.singlecheck) {
        that.$message.error("请选择站点");
        return;
      }
      if (that.singlecheck && that.params.stations.split(",").length > 1) {
        that.$message.error("请选择站点");
        return;
      }

      that.$api.get(
        "/DataAnalysis/SingleAnalysis",
        {
          dataType: that.params.dataType,
          stations: that.params.stations,
          beginTime: that.params.beginTime,
          endTime: that.params.endTime,
          channelIDs: that.params.channelIDs,
        },
        function (res) {
          if (res.code == 200) {
            that.chart.options.legend.data = res.data.legendData;
            that.chart.options.xAxis.data = res.data.xData;
            let series = [];
            for (let i = 0; i < res.data.legendData.length; i++) {
              series.push({
                name: res.data.legendData[i],
                type: "line",
                smooth: true,
                data: res.data.seriesData[i],
              });
            }
            that.chart.options.series = series;
            that.chart.myChange++;
          }
        },
        function () {},
        true
      );
    },
    GetChannelInfo() {
      let that = this;
      that.$api.get("/Channel/GetChannelInfo", null, function (res) {
        if (res.code == 200 && res.data != null) {
          that.channelList = res.data.filter((e) => {
            return e.ChannelMap != "WaterLevel";
          });

          that.selectedChannelIDs.push(that.channelList[0].ChannelMap);
        }
      });
    },
  },
  mounted() {
    let that = this;
    that.GetChannelInfo();
    that.params.endTime = this.$util.getSeason(0);
    that.params.beginTime = this.$util.getSeason(-3);
  },
  created() {},
  computed: {},
  watch: {
    "params.dataType"(newValue, oldValue) {
      let now = new Date();
      switch (newValue) {
        case "quarter":
          this.params.endTime = this.$util.getSeason(0);
          this.params.beginTime = this.$util.getSeason(-3);
          break;
        case "year":
          this.params.endTime = this.$util.formatDate(now, "yyyy");
          this.form.timeFormat = "yyyy";
          this.form.timeType = "year";
          this.params.beginTime = this.$util.formatDate(
            new Date(new Date(now.setFullYear(now.getFullYear() - 3))),
            "yyyy"
          );
          break;

        default:
          break;
      }
      this.QueryData();
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.custom-content {
  background: @backcolor;
  padding: 0 !important;
}
</style>